import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#07090B] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="bg-stage" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="bg-grid" />
        <div className="orb orb-green" />
        <div className="orb orb-red" />
      </div>
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[color:var(--ivory-muted)] mb-2">Admin sign in</div>
          <h1 className="font-display text-4xl text-white">Bangladesh Travels &amp; Tours AB</h1>
        </div>
        <form
          onSubmit={submit}
          className="p-7 rounded-2xl border border-white/10 bg-[#0E1216]/80 backdrop-blur-md space-y-5"
          data-testid="login-form"
        >
          <div>
            <label className="text-xs uppercase tracking-[0.25em] text-[color:var(--ivory-muted)] mb-2 block">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[color:var(--ivory-muted)]" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="email-input pl-10"
                placeholder="info@bdtt.se"
                data-testid="login-email"
              />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.25em] text-[color:var(--ivory-muted)] mb-2 block">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[color:var(--ivory-muted)]" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="email-input pl-10"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full pill pill-primary justify-center disabled:opacity-50"
            data-testid="login-submit"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center text-xs text-[color:var(--ivory-muted)] pt-3">
            <a href="/" className="hover:text-white">← Back to site</a>
          </div>
        </form>
      </div>
    </div>
  );
}
